import React, { PureComponent } from 'react'
import { DsBox, DsBoxProps, DsTypography } from '@am92/react-design-system'

type Props = {
  kicker: string
  title: string
  BoxProps?: DsBoxProps
}

export default class PageTitle extends PureComponent<Props> {
  render() {
    const { kicker, title, BoxProps = {} } = this.props
    return (
      <DsBox {...BoxProps}>
        <DsTypography
          component='div'
          color='text.secondary'
          variant='subheadingSemiboldDefault'
          sx={{ mb: 'var(--ds-spacing-quickFreeze)' }}
        >
          {kicker}
        </DsTypography>
        <DsTypography component='div' variant='headingBoldMedium'>
          {title}
        </DsTypography>
      </DsBox>
    )
  }
}
